import React from 'react';
import withLazyLoad from 'utils/withLazyLoad';
import withPid from 'utils/withPid';
import Slider from 'components/Slider';
import text0 from '../../images/0.png';

import Market from '../../components/Market';
import './style.scss';

const UpfintechTiger: React.FC = () => {
    return (
        <>
            <Slider className="banner upfintech-tiger-root">
                <div className="tradeup">
                    <div className="site-main" data-animation="a-flyTopIn">
                        <h5 className="brand">UP Fintech Tiger</h5>
                        <h3>
                            Let’s
                            <br />
                            TradeUP
                        </h3>
                        <p>
                            <b>$0</b> commissions
                            <br />
                            <b>$0</b> account minimum
                            <br />
                            <b>$0</b> data fees
                        </p>
                    </div>
                </div>
                <div className="market-trends">
                    <div className="site-main" data-animation="a-flyTopIn">
                        <h5 className="brand">UP Fintech Tiger</h5>
                        <h3>Spot Market Trends</h3>
                        <p>Stay up-to-date with our free streaming market datas</p>
                    </div>
                </div>
                <div className="stocks-and-etfs">
                    <div className="site-main" data-animation="a-flyTopIn">
                        <h5 className="brand">UP Fintech Tiger</h5>
                        <div className="text">
                            <p>Trade U.S. stocks and ETFs with</p>
                            <h3>$0 commissions </h3>
                            <img className="text-0-img" src={text0} alt="$0" />
                        </div>
                    </div>
                </div>
            </Slider>
            <Market />
        </>
    );
};

export default withLazyLoad(withPid('brand')(UpfintechTiger));
